import axios from 'axios'

// 微信登录
export const weixinLogin = (data) => {
    return axios({
        url: '/mall/phone/login/weixin/' ,
        method: 'post',
        data:data
    })
}

// 支付宝登录
export const alipayLogin = (data) => {
    return axios({
        url: '/mall/phone/login/alipay/' ,
        method: 'post',
        data:data
    })
}
// 获取登录信息
export const loginInit = (data) => {
    return axios({
        url: '/mall/phone/login/init/' ,
        method: 'post',
        data:data
    })
}
// 判断token
export const isTokenClass = (data) => {
    return axios({
        url: '/mall/phone/auth/verify/token/' ,
        method: 'post',
        data:data
    })
}

// 用户个人信息
export const getUserInfo = () => {
    return axios({
        url: '/mall/phone/user/info/' ,
        method: 'get'
    })
}
// 余额查询mall​/phone​/user​/money​
export const getUserMoney = (data) => {
    return axios({
        url: '/mall/phone/user/money/' ,
        method: 'get',
        params: data
    })
}
// 获取短信验证码
export const userBindCode = (data) => {
    return axios({
        url: '/mall/phone/user/bind/code/' ,
        method: 'post',
        data:data
    })
}
// 绑定手机号
export const userBindPhone = (data) => {
    return axios({
        url: '/mall/phone/user/bind/phone/' ,
        method: 'post',
        data:data
    })
}

// 微信授权获取openId
export const userAuthWeixin = (data) => {
    return axios({
        url: '/mall/phone/auth/weixin/' ,
        method: 'post',
        data:data
    })
}